/**
 * DeepDiveMinimized - Floating pill indicator when deep dive is minimized.
 *
 * Shows running/done/error state. Click to expand back to full drawer.
 */

import { Loader2, CheckCircle, AlertCircle, ChevronLeft } from 'lucide-react';
import { cn } from '@/lib/utils';

interface DeepDiveMinimizedProps {
  ticker: string;
  phase: 'running' | 'done' | 'error';
  onExpand: () => void;
}

export function DeepDiveMinimized({ ticker, phase, onExpand }: DeepDiveMinimizedProps) {
  return (
    <button
      onClick={onExpand}
      className={cn(
        'fixed right-4 bottom-4 z-30 flex items-center gap-2 px-4 py-2.5',
        'rounded-full bg-surface border shadow-lg',
        'hover:bg-surface-light transition-all hover:scale-105',
        phase === 'running' && 'border-primary/30',
        phase === 'done' && 'border-green-500/30',
        phase === 'error' && 'border-red-500/30',
      )}
    >
      {phase === 'running' && <Loader2 className="w-4 h-4 animate-spin text-primary" />}
      {phase === 'done' && <CheckCircle className="w-4 h-4 text-green-400" />}
      {phase === 'error' && <AlertCircle className="w-4 h-4 text-red-400" />}
      <span className="text-sm font-medium text-text-primary">{ticker}</span>
      <span className="text-[10px] text-text-muted">
        {phase === 'running' ? 'Analyzing...' : phase === 'done' ? 'Done' : 'Error'}
      </span>
      <ChevronLeft className="w-4 h-4 text-text-muted" />
    </button>
  );
}
